import { configureRequest } from '../../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../../networkRequests/apiClient/endpoints'
import { UserRole } from '../../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  GetLockerOrdersErrorResponse,
  GetLockerOrdersRequest,
  GetLockerOrdersSuccessResponse
} from './getLockerOrders.types'

export const getLockerOrdersApi = async (request: GetLockerOrdersRequest): Promise<GetLockerOrdersSuccessResponse> => {
  const response = await configureRequest({
    url: urls.admin.getLockerOrders,
    method: 'GET',
    params: Object.keys(request).length > 0 ? (request as Record<string, string | number | string[]>) : undefined,
    headers: {
      'X-User-Role': UserRole.admin
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as GetLockerOrdersSuccessResponse
  } else {
    throw response as GetLockerOrdersErrorResponse
  }
}

export default getLockerOrdersApi
